export default "__VITE_ASSET__xiy0w7U___"